"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_store_1 = require("owa-options-store");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var owa_options_orchestration_1 = require("owa-options-orchestration");
var FullOptionSearch_1 = require("./FullOptionSearch");
var FocusZone_1 = require("office-ui-fabric-react/lib/FocusZone");
var styles = require('./OptionsFull.scss');
var className = require('classnames/bind').bind(styles);
var CategoryEntry = mobx_react_1.observer(function (props) {
    var buttonStyles = {
        root: className(styles.category, {
            selectedCategory: owa_options_store_1.getStore().currentCategoryKey === props.category.key,
        }),
        flexContainer: styles.flexContainer,
        label: styles.categoryLabel,
    };
    var iconProps = {
        iconName: props.category.icon,
        styles: {
            root: styles.categoryIcon,
        },
    };
    return (React.createElement(Button_1.ActionButton, { styles: buttonStyles, key: props.category.key, onClick: function () { return owa_options_orchestration_1.selectCategory(props.category); }, iconProps: iconProps, text: owa_options_strings_1.default[props.category.titleStringKey] }));
});
var CategoriesColumn = /** @class */ (function (_super) {
    tslib_1.__extends(CategoriesColumn, _super);
    function CategoriesColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoriesColumn.prototype.render = function () {
        return (React.createElement("div", { className: styles.categoriesColumn },
            React.createElement("span", { className: styles.title, role: "heading", "aria-level": 2 }, owa_options_strings_1.default.options_title),
            React.createElement(FullOptionSearch_1.default, null),
            React.createElement(FocusZone_1.FocusZone, { direction: FocusZone_1.FocusZoneDirection.vertical }, owa_options_store_1.collectedOptions().map(function (category) { return (React.createElement(CategoryEntry, { category: category, key: category.key })); })),
            React.createElement(Button_1.CommandButton, { className: styles.viewQuickSettings, onClick: this.goToQuickOptions, iconProps: {
                    iconName: "ChevronLeft" /* ChevronLeft */,
                    styles: {
                        root: className(styles.icon, 'flipForRtl'),
                    },
                }, text: owa_options_strings_1.default.optionsFull_goToQuickOptions })));
    };
    CategoriesColumn.prototype.goToQuickOptions = function () {
        owa_options_orchestration_1.hideFullOptions(true /* showQuickOptions */);
    };
    CategoriesColumn = tslib_1.__decorate([
        mobx_react_1.observer
    ], CategoriesColumn);
    return CategoriesColumn;
}(React.Component));
exports.default = CategoriesColumn;
//# sourceMappingURL=CategoriesColumn.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/CategoriesColumn.js
// module id = 5286
// module chunks = 2